import { Navigate } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Redirects authenticated + onboarded users away from auth pages.
 * Unauthenticated users or those mid-onboarding pass through.
 */
export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user && user.onboardingCompleted) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
